import { render, staticRenderFns } from "./ChannelSwitch.vue?vue&type=template&id=e6e0ee9e&scoped=true&"
import script from "./ChannelSwitch.vue?vue&type=script&lang=ts&"
export * from "./ChannelSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelSwitch.vue?vue&type=style&index=0&id=e6e0ee9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e0ee9e",
  null
  
)

export default component.exports